
export function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isIOSDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
}

export function isAndroidDevice() {
  return /Android/i.test(navigator.userAgent);
}

export const getQueryParams = (url = window.location.search) => {
  const params = {};
  const search = url.startsWith('?') ? url : '?' + url.split('?')[1] || '';
  const query = new URLSearchParams(search);
  for (const [key, value] of query.entries()) {
    params[key] = value;
  }
  return params;
};

let linkprefix = "";

let bodyText = "Okay Boggler... what do you have to say...";

console.log("Encoded body text:", bodyText);

let smsNumber = process.env.REACT_APP_PHONE_NUMBER;
let whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;

if(isMobileDevice()) {
  if(isAndroidDevice()) {
    linkprefix = "smsto:";
  } else {
    linkprefix = "sms://";
  }
} else {
  linkprefix = "sms://";
}

let smsLinkURLToSendOnClick = encodeURI(linkprefix+smsNumber+"?body="+bodyText);
let whatsappLinkURLToSendOnClick = "whatsapp://send?phone=" + whatsappNumber;


if(process.env.REACT_APP_QA_MODE == false || process.env.REACT_APP_QA_MODE == "false") {
   console.log("QA Mode is OFF... Prod is ON!");
} else {
  if(window.localStorage.getItem("buckish-qa-password") === "super-duper-pooper") {
      console.log("QA Mode is ON but Password is correct");
   } else {
      console.log("QA Mode is ON and Password is incorrect");
   }
}

export const openMessengerApp = (language, platform = "sms", showBodyText = false) => {
  
  let theBodyText = showBodyText ? `&body=${bodyText}` : "";

  if(platform === "sms") {
      window.open(smsLinkURLToSendOnClick+theBodyText, "_self");
  } else {
    theBodyText = showBodyText ? `&text=${bodyText}` : "";
    window.open(whatsappLinkURLToSendOnClick+theBodyText, "_self")
  }

}

let API_URL = process.env.REACT_APP_API_URL || "https://the-boggler-api-96bc2fa97f2d.herokuapp.com/api";

if(process.env.NODE_ENV === "development" || process.env.REACT_APP_QA_MODE == "true") {
  API_URL = "http://localhost:4242/api" //"https://key-gator-shining.ngrok.app/api";
}

export const generateRandomString = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const authenticateUser = async (title, p) => {

  try {

    const response = await fetch(API_URL + '/journalist/validate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ title, p })
    });

    let data = await response.json();
    return { 
      isJournalist: data.success,
      journalistId: data.journalist_id,
      convoId: data.conversation_id,
      step: data.step, 
      stripe_checkout_session_id: data.stripe_checkout_session_id,
      ip_info: data.ip_info, 
      message: data.message
    }

  } catch (error) {
    console.error('Error:', error);
    return { response: { status: 200 }, data: { success: false, happyPathUser: false, message: 'Internal Server Error' } };
  }
};

export const getLanguage = () => {
  return window.localStorage.getItem("buckish-language") || "english";
}

export const setLanguage = (preferredLanguage) => {
  if(preferredLanguage === "sinhala") {
    window.localStorage.setItem("buckish-language", "sinhala");
  } else {
    window.localStorage.setItem("buckish-language", "english");
  }
};

export const authenticateAdminUser = async () => {

  const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/login/check`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
          token: window.localStorage.getItem('adminToken'),
          token_expiry: window.localStorage.getItem('adminTokenExpiry') 
      }),
    })

    const data = await response.json();

    if (data.success) {
        // Handle successful login
        console.log("Admin logged in successfully");
        const { isLoggedIn, token, token_expiry } = data;
        if(isLoggedIn) {
          window.localStorage.setItem('adminToken', token);
          window.localStorage.setItem('adminTokenExpiry', token_expiry);
        }
    } else {
        // Handle login error
        console.error("Admin login failed");
    }
    return data;
  }

  export const fetchGuideTypes = async () => {
        // Fetch guide types if needed
        const response = await fetch(`${process.env.REACT_APP_API_URL}/guide/guide-types`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        let guideTypes = [];
        if(data && data.guideTypes) {
            guideTypes = data.guideTypes.map((type) => ({
                ...type,
                imageUrl: getGuideTypeImageUrl(type.profilePictureKey)
            }));
        }
        return guideTypes;
    }

  export const getGuideTypeImageUrl = (profilePictureKey) => {
      if(!profilePictureKey || profilePictureKey === "" || profilePictureKey === "other") {
          return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
      } else {
          return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/${profilePictureKey}`;
      }
  }

  export const getGuideTypeImageUrlByHyphenatedTitle = async (hyphenatedTitle) => {
      if(!hyphenatedTitle || hyphenatedTitle === "" || hyphenatedTitle === "other") {
          return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
      } else {
          const info = await guideTypeInfoFromHyphen(hyphenatedTitle);
          return info.imageUrl || `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
      }
  }

  export const guideTypeInfoFromHyphen = async (type) => {
      let dataInfo = {};

      const response = await fetch(`${process.env.REACT_APP_API_URL}/guide/guide-type-info/${type}`, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json'
          },
      }).catch((error) => {
          console.error("Error fetching guide type info:", error);
          return {};
      });

      try {
          const data = await response.json();
          dataInfo = data?.guideType;
          if(!dataInfo) {
              return {};
          }
      } catch (error) {
          console.error("Error fetching guide type info:", error);
          return {};
      }

      const getPronouns = () => {
        if(dataInfo?.presumedGender === "female") {
          return ["she", "her", "her", "hers"];
        } else if(dataInfo?.presumedGender === "male") {
          return ["he", "him", "his", "his"];
        } else {
          return ["they", "them", "their", "theirs"];
        }
      }
      return {
        articleForType: getArticleByTitle(dataInfo?.title),
        presumedGender:   dataInfo?.presumedGender,
        pronouns: getPronouns(),
        title: dataInfo?.title, 
        description: dataInfo?.description, 
        profilePictureKey: dataInfo?.profilePictureKey, 
        imageUrl: getGuideTypeImageUrl(dataInfo?.profilePictureKey)
      };
  }

  export async function alertNativeFirst({ title, message, setShowWebAlert, action }) {
      // Fallback to IonAlert programmatically or a custom modal
      setShowWebAlert({ show: true, title: title, message: message, action: action });
  }

  export const capitalize = (s) => {
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
  }

 export const compareObjects = (a, b) => {
        let akeys = Object.keys(a);
        let bkeys = Object.keys(b);
        let len = akeys.length;
        if (len != bkeys.length) {
          return false;
        }
        for (var i = 0; i < len; i++) {            
            
            if (Array.isArray(a[akeys[i]])) {
                if (JSON.stringify(a[akeys[i]]) !== JSON.stringify(b[akeys[i]])) {
                    return false
                }
            } else {
                if (a[akeys[i]] !== b[akeys[i]]) {
                  return false;
                }
            }
        }
        return true;
    }  

  export const getArticleByTitle = (title) => {
      const vowels = ['A', 'E', 'I', 'O', 'U', 'a', 'e', 'i', 'o', 'u'];
      if(title && title.length > 0 && vowels.includes(title.charAt(0))) {
          return "an";
      } else {
          return "a";
      }
  }

  export const getGuideTypeMessageSegment = async (types) => {
      if(!types ||types && types.length === 0) {
          return "";
      } else {
        const response = await fetch(`${API_URL}/guide/guide-types-message-segment`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({ types })
        });
        const data = await response.json();
        return { messageSegmentRegardingTypes: data.messageSegmentRegardingTypes || "", articleForType: data.articleForType || "a"  };
      }
  };

  export const tzMap = {
    "UTC−11:00 (SST)": "Pacific/Pago_Pago",
    "UTC−10:00 (HT)": "Pacific/Honolulu",
    "UTC−09:30 (MART)": "Pacific/Marquesas",
    "UTC−09:00 (AKT)": "America/Anchorage",
    "UTC−08:00 (PT)": "America/Los_Angeles",
    "UTC−07:00 (MT)": "America/Denver",
    "UTC−06:00 (CT)": "America/Chicago",
    "UTC−05:00 (ET)": "America/New_York",
    "UTC−04:00 (AST)": "America/Halifax",
    "UTC−04:00 (VET)": "America/Caracas",
    "UTC−04:00 (AST)": "America/Puerto_Rico",
    "UTC−03:30 (NST)": "America/St_Johns",
    "UTC−03:00 (BRT)": "America/Sao_Paulo",
    "UTC±00:00 (GMT)": "Europe/London",
    "UTC+01:00 (CET)": "Europe/Paris",
    "UTC+02:00 (EET)": "Europe/Bucharest",
    "UTC+03:00 (MSK)": "Europe/Moscow",
    "UTC+03:30 (IRST)": "Asia/Tehran",
    "UTC+04:00 (GST)": "Asia/Dubai",
    "UTC+05:00 (PKT)": "Asia/Karachi",
    "UTC+05:30 (IST)": "Asia/Kolkata",
    "UTC+06:00 (BST)": "Asia/Dhaka",
    "UTC+07:00 (ICT)": "Asia/Bangkok",
    "UTC+08:00 (CST)": "Asia/Shanghai",
    "UTC+08:30 (KST)": "Asia/Pyongyang",
    "UTC+09:00 (JST)": "Asia/Tokyo",
    "UTC+09:30 (ACST)": "Australia/Adelaide",
    "UTC+10:00 (AEST)": "Australia/Sydney",
    "UTC+10:30 (LHST)": "Australia/Lord_Howe",
    "UTC+11:00 (SBT)": "Pacific/Guadalcanal",
    "UTC+12:00 (NZST)": "Pacific/Auckland",
    "Pacific/Pago_Pago":  "Pacific/Pago_Pago",
    "Pacific/Honolulu": "Pacific/Honolulu",
    "Pacific/Marquesas": "Pacific/Marquesas",
    "America/Anchorage": "America/Anchorage",
    "America/Los_Angeles": "America/Los_Angeles",
    "America/Denver": "America/Denver",
    "America/Chicago": "America/Chicago",
    "America/New_York": "America/New_York",
    "America/Halifax": "America/Halifax",
    "America/Caracas":"America/Caracas",
    "America/Puerto_Rico": "America/Puerto_Rico",
    "America/St_Johns": "America/St_Johns",
    "America/Sao_Paulo": "America/Sao_Paulo",
    "Europe/London": "Europe/London",
    "Europe/Paris": "Europe/Paris",
    "Europe/Bucharest": "Europe/Bucharest",
    "Europe/Moscow": "Europe/Moscow",
    "Asia/Tehran": "Asia/Tehran",
    "Asia/Dubai": "Asia/Dubai",
    "Asia/Karachi": "Asia/Karachi",
    "Asia/Kolkata": "Asia/Kolkata",
    "Asia/Colombo": "Asia/Colombo",
    "Asia/Dhaka": "Asia/Dhaka",
    "Asia/Bangkok": "Asia/Bangkok",
    "Asia/Shanghai": "Asia/Shanghai",
    "Asia/Tokyo": "Asia/Tokyo",
    "Australia/Adelaide": "Australia/Adelaide",
    "Australia/Sydney": "Australia/Sydney",
    "Australia/Lord_Howe": "Australia/Lord_Howe",
    "Pacific/Guadalcanal": "Pacific/Guadalcanal",
    "Pacific/Auckland": "Pacific/Auckland"
};
